import React, { PureComponent } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import history from './core/history';

import { UserStore } from './core/user-store';

import Page from './pages/Page';
import PageNotFound from './pages/not-found/PageNotFound';

import HomePage from './pages/home/HomePage';

import LoginPage from './pages/login/LoginPage';
import SignUpPage from './pages/sign-up/SignUpPage';

import DashboardPage from './pages/dashboard/DashboardPage';
import CatalogPage from './pages/catalog/CatalogPage';

import { redirectToLogin } from './core/authentication';
import { PAGES_BASE_PATHNAMES } from './core/consts';

interface StoresProps {
  userStore?: UserStore;
}

type Props = StoresProps;

interface State {}

const AppRouter = inject('userStore')(
  observer(
    class AppRouter extends PureComponent<Props, State> {
      render() {
        const { areSettingsLoaded, userData } = this.props.userStore;

        if (!areSettingsLoaded) {
          return null;
        }

        return (
          <Router history={history}>
            <Switch>
              (
              <Route
                path={`${PAGES_BASE_PATHNAMES.Catalog}/:id/:version?`}
                render={() => {
                  if (userData && userData.id) {
                    return (
                      <Page>
                        <CatalogPage />
                      </Page>
                    );
                  }
                  redirectToLogin();
                  return null;
                }}
              />
              )
              <Route
                path={PAGES_BASE_PATHNAMES.Dashboard}
                render={() => {
                  if (userData && userData.id) {
                    return (
                      <Page>
                        <DashboardPage />
                      </Page>
                    );
                  }
                  redirectToLogin();
                  return null;
                }}
              />
              {process.env.REACT_APP_IS_STAGED_CONTENT_ONLY !== 'true' && (
                <Route
                  path={PAGES_BASE_PATHNAMES.SignUp}
                  render={() => {
                    return (
                      <Page>
                        <SignUpPage />
                      </Page>
                    );
                  }}
                />
              )}
              {
                <Route
                  path={PAGES_BASE_PATHNAMES.Login}
                  render={() => {
                    return (
                      <Page>
                        <LoginPage />
                      </Page>
                    );
                  }}
                />
              }
              <Route
                exact
                path="/"
                render={() => (
                  <Page>
                    <HomePage />
                  </Page>
                )}
              />
              <Route path="*" render={() => <PageNotFound />} />
            </Switch>
          </Router>
        );
      }
    }
  )
);

export default AppRouter;
